import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=0f3b8b2e&scoped=true&"
import script from "./ChatModal.vue?vue&type=script&lang=js&"
export * from "./ChatModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=0f3b8b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b8b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3b8b2e')) {
      api.createRecord('0f3b8b2e', component.options)
    } else {
      api.reload('0f3b8b2e', component.options)
    }
    module.hot.accept("./ChatModal.vue?vue&type=template&id=0f3b8b2e&scoped=true&", function () {
      api.rerender('0f3b8b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatModal.vue"
export default component.exports